import React from 'react'
import {NavLink} from "react-router-dom";
import {Button} from "primereact/button";
import {NAVIGATION_ITEM} from "../../../../constants/navigationItems";
import {getTournamentsystem} from "../../../../constants/tournamentSystems";

const vorhanden = (wert) => wert !== null && wert !== undefined && wert !== "";

/**
 * Kopfbereich mit Name, Veranstalter, Status, den wichtigsten Eckdaten und der passenden Hauptaktion.
 */
export default function EventHeader({tournamentWrapper, verbunden, appCall, aktionen, onRefresh}) {

    const t = tournamentWrapper.turnierMain;
    const veranstalter = vorhanden(tournamentWrapper.eventOperatorBezeichnung) ? tournamentWrapper.eventOperatorBezeichnung : t.eventOperatorBezeichnung;
    const system = getTournamentsystem(t.turniersystem);

    const getStatusChip = () => {
        if (t.tournamentstatus === "neu") {
            return t.registrationAllowed
                ? <span className="dhpt-chip dhpt-chip-offen">Anmeldung offen</span>
                : <span className="dhpt-chip">Geplant</span>;
        }
        if (t.tournamentstatus === "gestartet") {
            return verbunden
                ? <span className="dhpt-chip dhpt-chip-live">Live</span>
                : <span className="dhpt-chip">Läuft</span>;
        }
        if (t.tournamentstatus === "abgeschlossen") {
            return <span className="dhpt-chip">Abgeschlossen</span>;
        }
        return <span className="dhpt-chip">{t.tournamentstatus}</span>;
    }

    const anzahlTeilnehmer = t.tournamentPlayerEntities.length + (vorhanden(t.maxAnzahlTeilnehmer) && t.tournamentstatus === "neu" ? " / " + t.maxAnzahlTeilnehmer : "") + " Teilnehmer";

    return <header>
        {!appCall &&
            <div className="dhpt-topbar">
                <NavLink to={NAVIGATION_ITEM.PUBLIC_TOURNAMENTS.route} aria-label="Zur Eventübersicht">
                    <img alt="Darthelfer" src={"/images/darthelfer_quer_weiss.png"} className="dhpt-logo"/>
                </NavLink>
                <nav className="dhpt-crumb" aria-label="Brotkrumen">
                    <NavLink to={NAVIGATION_ITEM.PUBLIC_TOURNAMENTS.route}>Events</NavLink>
                    {vorhanden(t.eventOperatorId) && vorhanden(veranstalter) && <>
                        <i className="pi pi-chevron-right" aria-hidden="true"/>
                        <NavLink to={NAVIGATION_ITEM.PUBLIC_EVENTOPERATOR.route + "/" + t.eventOperatorId}>{veranstalter}</NavLink>
                    </>}
                </nav>
            </div>
        }
        {appCall &&
            <div className="dhpt-topbar">
                <img alt="Darthelfer" src={"/images/darthelfer_quer_weiss.png"} className="dhpt-logo"/>
            </div>
        }
        <div className="dhpt-hero">
            <div className="dhpt-hero-zeile">
                {getStatusChip()}
                {vorhanden(veranstalter) && <span className="dhpt-meta-text">{veranstalter}</span>}
            </div>
            <h1 className="dhpt-titel">{t.bezeichnung}</h1>
            <div className="dhpt-meta">
                {vorhanden(t.beginnMitUhrzeitString) && <span><i className="pi pi-calendar" aria-hidden="true"/>{t.beginnMitUhrzeitString}</span>}
                {vorhanden(t.austragungsortOrt) && <span><i className="pi pi-map-marker" aria-hidden="true"/>{t.austragungsortOrt}</span>}
                <span><i className="pi pi-users" aria-hidden="true"/>{anzahlTeilnehmer}</span>
                {system !== undefined && system !== null && <span><i className="pi pi-sitemap" aria-hidden="true"/>{system.text}</span>}
            </div>
            {t.tournamentstatus === "gestartet" && !verbunden &&
                <div className="dhpt-verbindung">
                    <span>Keine Live-Verbindung, die Daten werden gerade nicht automatisch aktualisiert.</span>
                    <Button label="Neu laden" icon="pi pi-refresh" className="p-button-sm p-button-outlined dhpt-button-hell" onClick={onRefresh}/>
                </div>
            }
            {aktionen.length > 0 &&
                <div className="dhpt-aktionen">
                    {aktionen.map(aktion => <Button key={aktion.label} label={aktion.label} icon={aktion.icon}
                                                    className={aktion.primaer ? "" : "p-button-outlined dhpt-button-hell"}
                                                    onClick={aktion.onClick}/>)}
                </div>
            }
        </div>
    </header>
}
